
export class UserModel {
  async changePublicationVisibility(_entity, _idcod, _status) {
    return await new Promise((resolve, reject) => {
      APICRUD[_entity].SetVisibility(_idcod, _status, _callback)
        .then(resolve)
        .catch(reject)
    });
  }
}
